import { Injectable } from '@angular/core';
import {
  CommandDefinition,
  CommandHelper,
  SortOrderCommandService,
  SupportedOrder,
} from '@app/shared/quick-commands';
import { PreferenceStorageService } from '@app/shared/services/preference-storage.service';
import { RecentlyUsedService } from '@app/shared/services/recently-used.service';

@Injectable({
  providedIn: 'root',
})
export class SortOrderCommand implements CommandDefinition<[SupportedOrder | 'reset']> {
  countInvocations = false;
  filter = 'automatic' as const;
  icon = 'far fa-sort';
  label = 'quickCommands.commands.sortOrder';
  name = 'quickCommandOrder';

  constructor(
    private preferenceStorageService: PreferenceStorageService,
    private recentlyUsedService: RecentlyUsedService,
    private sortOrderCommandService: SortOrderCommandService
  ) {}

  action(_: string, [order]: [SupportedOrder | 'reset']) {
    if (order == null) {
      return this.getAvailableOrderings();
    }

    if (order === 'reset') {
      this.recentlyUsedService.reset('quick-command');
    } else {
      this.preferenceStorageService.updatePreference('quick-commands:command-order', order);
    }

    return CommandHelper.return();
  }

  private getAvailableOrderings() {
    return CommandHelper.list$(this.sortOrderCommandService.sortOrder$, (sortOrder) => {
      return {
        filterAutomatically: true,
        sections: [
          {
            label: '',
            name: 'order',
          },
          {
            label: 'quickCommands.commands.sortOrder.commands',
            name: 'commands',
          },
        ],
        values: [
          {
            active: sortOrder === 'default',
            icon: 'far fa-sort-alpha-up',
            label: 'quickCommands.commands.sortOrder.default',
            section: 'order',
            value: 'default' as const,
          },
          {
            active: sortOrder === 'last-used',
            icon: 'far fa-clock',
            label: 'quickCommands.commands.sortOrder.lastUsed',
            section: 'order',
            value: 'last-used' as const,
          },
          {
            active: sortOrder === 'most-used',
            icon: 'far fa-sort-amount-up',
            label: 'quickCommands.commands.sortOrder.mostUsed',
            section: 'order',
            value: 'most-used' as const,
          },
          {
            label: 'quickCommands.commands.sortOrder.reset',
            section: 'commands',
            value: 'reset' as const,
          },
        ],
      };
    });
  }
}
